type ApiErrorOptions = {
  cause: Error;
  status: number;
  userMessage?: string;
};

type UnauthorizedApiErrorOptions = Omit<ApiErrorOptions, "status"> & {
  requestAuthentication: "public" | "session";
};

type RequestValidationApiErrorOptions = Omit<ApiErrorOptions, "status">;

export class ApiError extends Error {
  readonly status: number;
  readonly userMessage: string | undefined;
  override readonly cause: Error;

  constructor({ cause, status, userMessage }: ApiErrorOptions) {
    super(cause.message, { cause });
    this.name = "ApiError";
    this.status = status;
    this.userMessage = userMessage;
    this.cause = cause;
  }
}

export class UnauthorizedApiError extends ApiError {
  readonly requestAuthentication: "public" | "session";

  constructor({
    cause,
    requestAuthentication,
    userMessage,
  }: UnauthorizedApiErrorOptions) {
    super({ cause, status: 401, userMessage });
    this.name = "UnauthorizedApiError";
    this.requestAuthentication = requestAuthentication;
  }
}

export class RequestValidationApiError extends ApiError {
  constructor({ cause, userMessage }: RequestValidationApiErrorOptions) {
    super({ cause, status: 422, userMessage });
    this.name = "RequestValidationApiError";
  }
}
